import { useRef, useMemo } from 'react';
import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';
import activeTreatments from './treatments';
import { PricingExperiments } from '~shared/types/pricing/experiments';

import { ExperimentTreatment } from './types';

/**
 * This hook returns an object containing active experiment components
 * intended for full component swaps within a page or an entire page component itself
 * @returns ExperimentTreatment
 */

export default function useTreatment(conditions = true): ExperimentTreatment {
  const assignments = usePricingExperiments();
  const treatments = useRef({} as ExperimentTreatment);

  useMemo(() => {
    Object.keys(assignments).forEach(assignment => {
      const exp = assignments[assignment as keyof PricingExperiments];

      treatments.current = {
        ...treatments.current,
        [assignment]: {},
      };

      if (exp.hasAssignment && exp.treatmentName in activeTreatments && conditions) {
        const { name, component } = activeTreatments[exp.treatmentName];
        treatments.current = {
          ...treatments.current,
          [assignment]: {
            ...treatments.current[assignment],
            [name]: component,
          },
        };
      }
    });
  }, [assignments, treatments, conditions]);

  return treatments.current;
}
